import React, { useReducer } from 'react';
import { athletesBySchool, getAthletesByClub, listAthletes } from '../graphql/queries';
import { API } from 'aws-amplify';
import { deleteAthlete } from '../graphql/mutations';

const AthleteContext = React.createContext();
const _athleteState = {
    athletes : []
};

function athleteReducer(state , {type , data}){
    switch (type) {
        case "SET_ATHLETES" : {
            return {
                ...state,
                athletes : data
            };
        }
        default:
            break;
    }
}

const AthleteProvider = ({ children }) => {
    const [athleteState, dispatch  ] = useReducer(athleteReducer , _athleteState);
    async function getAthletes(){
        try {
            const {data  : { listAthletes : {items : athletes}}} = await API.graphql({query : listAthletes});
            dispatch({type : "SET_ATHLETES" , data : athletes});
        } catch (err) {
            console.log(err);
        }
    }
    async function getAthletesForClub(clubID){
        try{
            const {data : {getAthletesByClub  : {items : athletes}}} = await API.graphql({query : getAthletesByClub , variables : { clubID }});
            dispatch({type : "SET_ATHLETES" , data : athletes});
        }
        catch(err){
            console.log(err);
        }
    }
    async function getAthletesForSchool(schoolID){
        try{
            const {data : {athletesBySchool  : {items : athletes}}} = await API.graphql({query : athletesBySchool , variables : { schoolID }});
            dispatch({type : "SET_ATHLETES" , data : athletes});
        }
        catch(err){
            console.log(err);
        }
    }
    async function removeAthlete(details){
        return await API.graphql({query : deleteAthlete , variables : { input : details }});
    }
    return (
        <AthleteContext.Provider value={{ athleteState , getAthletes , getAthletesForClub , getAthletesForSchool, removeAthlete}}>
            {children}
        </AthleteContext.Provider>
    );
};
export { AthleteContext , AthleteProvider};